import css_text from '/srv/www/htdocs/loc/app/styles/web_components/switch_toggle.css';

const has_element_internals = !!(window.ElementInternals && 'attachInternals' in HTMLElement.prototype);

export class YalwaSwitchToggle extends HTMLElement {
	
	static formAssociated = true;
	
	static get observedAttributes() {
		return ['checked', 'disabled', 'name', 'value', 'form'];
	}
	
	constructor() {
		super();
		if (!this.shadowRoot) {
			this.attachShadow({mode: 'open'});
			this.apply_css();
		}
		this._internals = has_element_internals ? this.attachInternals() : null;
		this._form_proxy = null;
	}
	
	connectedCallback() {
		this.setAttribute('role', 'switch');
		this.setAttribute('tabindex', this.disabled ? '-1' : '0');
		
		this.sync_form_state();
		this.render();
		jQuery(this).on('click', this.toggle.bind(this));
		jQuery(this).on('keydown', (e) => {
			if (e.key === ' ' || e.key === 'Enter') {
				e.preventDefault();
				this.toggle();
			}
		});
		jQuery(this).removeClass('invisible');
	}
	
	async apply_css() {
		await yalwa.basics.check_stylesheet_polyfill_needed();
		const sheet = new CSSStyleSheet();
		sheet.replaceSync(css_text);
		this.shadowRoot.adoptedStyleSheets = [sheet];
	}
	
	attributeChangedCallback(name, old_value, new_value) {
		if (name === 'disabled') {
			this.setAttribute('tabindex', new_value !== null ? '-1' : '0');
		}
		if (name === 'checked') {
			this.setAttribute('aria-checked', new_value !== null ? 'true' : 'false');
		}
		
		if (!has_element_internals && ['name', 'value', 'checked', 'form'].includes(name)) {
			this.sync_form_proxy();
		}
		
		if (['name', 'value', 'checked', 'disabled', 'form'].includes(name)) {
			this.sync_form_state();
		}
	}
	
	sync_form_state() {
		const is_checked = this.hasAttribute('checked');
		const value = this.getAttribute('value') || '1';
		const name = this.getAttribute('name');

		if (has_element_internals && this._internals) {
			const submission_value = is_checked ? value : null;
			this._internals.setFormValue(submission_value);
			this._internals.setValidity({});
		} else {
			this.ensure_form_proxy();
			if (!this._form_proxy) {
				return;
			}

			const id = this.getAttribute('form');
			const target_form = id ? document.getElementById(id) : this.closest('form');

			if (target_form && this._form_proxy.parentNode !== target_form) {
				target_form.appendChild(this._form_proxy);
			}

			if (name) {
				this._form_proxy.name = name;
				this._form_proxy.value = value;
				this._form_proxy.checked = is_checked;
				this._form_proxy.disabled = this.hasAttribute('disabled');
			} else {
				this._form_proxy.removeAttribute('name');
			}
		}
	}
	
	toggle() {
		if (this.disabled) {
			return;
		}
		this.checked = !this.checked;
		this.dispatchEvent(new Event('change', {bubbles: true}));
	}
	
	get disabled() {
		return this.hasAttribute('disabled');
	}
	
	set disabled(value) {
		if (value) {
			this.setAttribute('disabled', '');
		} else {
			this.removeAttribute('disabled');
		}
	}
	
	get checked() {
		return this.hasAttribute('checked');
	}
	
	set checked(value) {
		if (value) {
			this.setAttribute('checked', '');
		} else {
			this.removeAttribute('checked');
		}
	}
	
	get value() {
		return this.getAttribute('value');
	}
	
	set value(val) {
		this.setAttribute('value', val);
	}
	
	get name() {
		return this.getAttribute('name');
	}
	
	set name(val) {
		this.setAttribute('name', val);
	}
	
	render() {
		this.shadowRoot.innerHTML = `
			<span class="label" part="label"><slot></slot></span>
			<div class="switch" part="track"></div>
		`;
	}
	
	ensure_form_proxy() {
		if (this._form_proxy) {
			return;
		}
		const input = document.createElement('input');
		input.type = 'checkbox';
		input.style.display = 'none';
		input.setAttribute('aria-hidden', 'true');
		
		const id = this.getAttribute('form');
		const target_form = id ? document.getElementById(id) : this.closest('form');
		(target_form ?? this).appendChild(input);
		
		this._form_proxy = input;
	}
}

customElements.define('yalwa-switch_toggle', YalwaSwitchToggle);